<template>
  <div class="qaqc-overview-status-card qaqc-test-plot-wrapper">
    <h6 class="qaqc-status-panel-title">Quality Control Status</h6>
    <p class="qaqc-status-panel-subtitle">{{ panel.subtitle }}</p>
    <div class="qaqc-status-panel-blocks">
      <div class="qaqc-status-block qaqc-status-passed">
        <div class="qaqc-status-block-content">
          <v-img :src="icons['check-circle']" width="40" height="40"/>
          <span class="qaqc-status-block-title">Passed QC</span>
          <span class="qaqc-status-block-details">{{ panel.passed.count }} of {{ panel.passed.total }} tests</span>
        </div>
        <div class="qaqc-status-block-pill-row">
            <span class="qaqc-status-block-pill">{{ panel.passed.percent }}</span>
          </div>
      </div>
      <div class="qaqc-status-block qaqc-status-review">
        <div class="qaqc-status-block-content">
          <v-img :src="icons['alert-circle-outline']" width="40" height="40"/>
          <span class="qaqc-status-block-title">Needs Review</span>
          <span class="qaqc-status-block-details">{{ panel.needsReview.count }} of {{ panel.needsReview.total }} tests</span>
          
        </div>
        <div class="qaqc-status-block-pill-row">
            <span class="qaqc-status-block-pill">{{ panel.needsReview.percent }}</span>
        </div>
      </div>
      <div class="qaqc-status-block qaqc-status-failed">        
        <div class="qaqc-status-block-content">
          <v-img :src="icons['close-circle']" width="40" height="40"/>
          <span class="qaqc-status-block-title">Failed QC</span>
          <span class="qaqc-status-block-details">{{ panel.failed.count }} of {{ panel.failed.total }} tests</span>
        </div>
        <div class="qaqc-status-block-pill-row">
            <span class="qaqc-status-block-pill">{{ panel.failed.percent }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QCStatusPanel",
  data() {
    return { 
      icons: {
        'check-circle': require('@/assets/Svg/check-circle.svg'),
        'alert-circle-outline': require('@/assets/Svg/alert-circle-outline.svg'),
        'close-circle': require('@/assets/Svg/close-circle.svg'),
      },
     };
  },
  props: {
    panel: {
      type: Object,
      required: true,
      default: () => ({
        passed: { count: 0, total: 0, percent: "0%" },
        needsReview: { count: 0, total: 0, percent: "0%" },
        failed: { count: 0, total: 0, percent: "0%" },
        subtitle: "",
      }),
    },
    sampleIds: { type: Array, default: () => [] },
    selectedSampleIds: { type: Array, default: () => [] },
  },
  emits: ["update:selectedSampleIds"],
  methods: {
    addSampleId(id) {
      if (this.selectedSampleIds.includes(id)) return;
      this.$emit("update:selectedSampleIds", [...this.selectedSampleIds, id]);
    },
    removeSampleId(id) {
      this.$emit(
        "update:selectedSampleIds",
        this.selectedSampleIds.filter((s) => s !== id)
      );
    },
  },
};
</script>
